import ClickableListItem from 'LuxKit/List/ClickableListItem'
import ListItemThumbnail from 'LuxKit/List/ListItemThumbnail'
import ListItemLoadingSkeleton from 'LuxKit/List/ListItemLoadingSkeleton'
import useMerchandise from 'hooks/Merchandise/useMerchandise'
import useMerchandiseBrand from 'hooks/Merchandise/useMerchandiseBrand'
import useMerchandiseCategory from 'hooks/Merchandise/useMerchandiseCategory'
import React, { useMemo } from 'react'
import Image from 'components/Common/Image'
import ListItemPrice from 'LuxKit/List/ListItemPrice'
import qs from 'qs'
import { getMerchandiseCategorySearchUrl } from '../merchandiseUtils'

interface Props {
  itemId: string;
  type: 'category' | 'brand' | 'product';
}

function MerchandiseSearchFormResultItem(props: Props) {
  const { itemId, type } = props

  const [merchandise] = useMerchandise(itemId, { disabled: type !== 'product' })
  const [brand] = useMerchandiseBrand(itemId, { disabled: type !== 'brand' })
  const [category] = useMerchandiseCategory({ id: itemId }, { disabled: type !== 'category' })

  const itemData = useMemo(() => {
    switch (type) {
      case 'product':
        return {
          label: merchandise?.name,
          subtitle: merchandise?.brand.name,
          image: merchandise?.images[0],
          price: merchandise?.leadVariant.price,
          to: `/shop/offer/${merchandise?.slug}/${merchandise?.id}`,
        }
      case 'brand':
        const query = qs.stringify({
          brands: brand?.id,
        })
        return {
          label: brand?.name,
          image: brand?.logo ?? brand?.image,
          to: `/search/shop/?${query}`,
        }
      case 'category':
        return {
          label: category?.name,
          image: category?.image,
          to: category ? getMerchandiseCategorySearchUrl(category) : undefined,
        }
    }
  }, [type, merchandise, brand, category])

  if (!itemData.label) {
    return <ListItemLoadingSkeleton
      startIcon
      subtitle={type === 'product'}
    />
  }

  return <ClickableListItem
    title={<b>{itemData.label}</b>}
    subtitle={itemData.subtitle}
    startIcon={<ListItemThumbnail>
      <Image
        fit="center"
        image={itemData.image}
        height={48}
        width={48}
      />
    </ListItemThumbnail>}
    to={itemData.to}
  >
    {!!itemData.price && <ListItemPrice
      price={itemData.price}
      label="From"
      size="small"
    />}
  </ClickableListItem>
}

export default MerchandiseSearchFormResultItem
